import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { IoTDevListStyle } from './IoTDevListStyle';
import {
  GetIoTBoxDeviceLists,
  IoTBoxDeviceLists,
  SetInstructManualCollection,
  V_IOTBOX_DEV_LIST,
  SetStudyCollection,
} from './IoTDevList';
import IotDevListStatErrorDialog from './IotDevListStatErrorDialog';

type IotDevListStatButtonProps = {
  iotBoxData: V_IOTBOX_DEV_LIST;
};

const IotDevListStatButton: React.FC<IotDevListStatButtonProps> = (props) => {
  const pageStyle = IoTDevListStyle();
  const { t } = useTranslation();
  const [openErrorList, setOpenErrorList] = useState<boolean>(false);

  /**
   * 状態の色
   * @param sate
   * @returns
   */
  const getSENSOR_COLMNGSStatusColor = (sate?: number): string => {
    if (sate == undefined) return 'silver';

    switch (sate) {
      case 0: //正常
        return 'green';
      case 1: //軽故障
        return '#E4C068';
      case 2: //重故障
        return 'red';
      case 4: //停止中
        return 'silver';
      default:
        //不明
        return 'silver';
    }
  };

  /**
   * ラベル時の文字色取得
   * @param sate
   * @returns
   */
  const getLabelTextColor = (sate?: number): string => {
    let displayColor = sate == 1 ? 'black' : 'white';
    return displayColor;
  };

  /**
   * ボタンの文字色取得
   * @param sate
   * @returns
   */
  const getButtonTextColor = (sate?: number): string => {
    if (sate == undefined) return 'silver';

    switch (sate) {
      case 0: //正常
        return 'green';
      case 1: //軽故障
        return '#E4C068';
      case 2: //重故障
        return 'red';
      case 4: //停止中
        return 'silver';
      default:
        //不明
        return 'silver';
    }
  };

  /**
   *　状態の表示文字
   * @param sate
   * @returns
   */
  const getSENSOR_COLMNGSStatus = (sate?: number): string => {
    if (sate == undefined) return t('IoTDevListGrid.不明', '不明');

    switch (sate) {
      case 0:
        return t('IoTDevListGrid.正常', '正常');
      case 1:
        return t('IoTDevListGrid.軽故障', '軽故障');
      case 2:
        return t('IoTDevListGrid.重故障', '重故障');
      case 4:
        return t('IoTDevListGrid.停止中', '停止中');
      default:
        return t('IoTDevListGrid.不明', '不明');
    }
  };

  /**
   * エラーログ日時選択ダイアログOPEN
   */
  const errorListDialogOpenAction = () => {
    setOpenErrorList(true);
  };

  /**
   * エラーログ日時選択閉じる
   */
  const errorListDialogCloseAction = () => {
    setOpenErrorList(false);
  };

  return (
    <>
      {/**軽故障・重故障の場合はボタンに変更、それ以外はラベル表示 */}
      {props.iotBoxData.SENSOR_STATUS !== 1 && props.iotBoxData.SENSOR_STATUS !== 2 ? (
        <div
          style={{
            background: getSENSOR_COLMNGSStatusColor(props.iotBoxData.SENSOR_STATUS),
            color: getLabelTextColor(props.iotBoxData.SENSOR_STATUS),
            padding: '5px',
          }}
        >
          {getSENSOR_COLMNGSStatus(props.iotBoxData.SENSOR_STATUS)}
        </div>
      ) : (
        <Button
          className={pageStyle.buttonStyle}
          style={{
            borderColor: getSENSOR_COLMNGSStatusColor(props.iotBoxData.SENSOR_STATUS),
            color: getButtonTextColor(props.iotBoxData.SENSOR_STATUS),
            width: '130px',
          }}
          variant="outlined"
          onClick={(e) => errorListDialogOpenAction()}
        >
          {getSENSOR_COLMNGSStatus(props.iotBoxData.SENSOR_STATUS)}
        </Button>
      )}
      <IotDevListStatErrorDialog
        open={openErrorList}
        onClose={errorListDialogCloseAction}
        iotBoxData={props.iotBoxData}
      ></IotDevListStatErrorDialog>
    </>
  );
};

export default IotDevListStatButton;
